// import React from 'react';
// import './Result.css'; // Import external CSS for modern styles

// const Result = () => {
//   return (
//     <div className="result-container">
//       <h1>Quiz Submitted</h1>
//       <p>Your quiz results have been successfully submitted. Thank you for participating!</p>
//     </div>
//   );
// };

// export default Result;


import React, { useEffect, useState,useContext } from 'react';
import axios from 'axios';
import './Result.css'; // Import external CSS for modern styles
import { AuthContext } from '../../context/authContext';
const Result = () => {
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const { currentUser } = useContext(AuthContext);
  // const userId = "106077"; // Replace with dynamic userId or get it from the login context or route params
  const userId = currentUser?.portalID
  useEffect(() => {
      
    // Fetch the quiz result by userId
    const fetchResult = async () => {
      try {
        const response = await axios.get(`http://162.210.199.3:3001/api/quiz/results/${userId}`);
        setResult(response.data);
      } catch (err) {
        setError('Failed to fetch result. Please try again later.');
      }
    };

    fetchResult();
  }, []);

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div className="result-container">
      <h1>Your quiz results</h1>
      {result ? (
        <div>
          {/* <p>Name: {result.name}</p>
          <p>Department: {result.department}</p> */}
          <h2>
            Result: {result.correctAnswers} / {result.totalQuestions}
          </h2>
          {/* <p>Percentage: {result.percentage}%</p> */}
          <h2>Thank you</h2>
        </div>
      ) : (
        <p>Loading your quiz results...</p>
      )}
    </div>
  );
};

export default Result;

// import React from 'react';

// const Result = () => {
//   return (
//     <div className="results">
//       <h1>Quiz Submitted</h1>
//       <p>Your quiz results have been successfully submitted. Thank you for participating!</p>
//     </div>
//   );
// };

// export default Result;
